module.exports = __webpack_public_path__ + "static/media/hcl.403dae09.jpg";